/**
 * LMTM 商品一覧
 *  - 絞り込み・並び替えは Shopify 標準（URL パラメータ）。チェックすると即送信する
 *  - SP は絞り込みを全画面パネルで開閉
 *  - 「+ VIEW MORE」は次ページを取って下に足す（ページ遷移なし）
 *  - 右下の TOP ボタン
 */
(function () {
  'use strict';

  // 並び替えは絞り込みの有無に関わらず動くよう、URL を直接書き換える
  function initSort(root) {
    var select = root.querySelector('[data-lmtm-sort]');
    if (!select) return;

    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  function initFacets(root) {
    var form = root.querySelector('[data-lmtm-facets]');
    if (!form) return;

    // チェックの変更で即送信。URL に状態が乗るので戻るボタンも効く
    form.addEventListener('change', function () {
      form.submit();
    });

    var openers = root.querySelectorAll('[data-lmtm-facets-open]');
    var closers = form.querySelectorAll('[data-lmtm-facets-close]');

    function setOpen(open) {
      form.dataset.open = open ? 'true' : 'false';
      document.body.classList.toggle('overflow-hidden', open);
      openers.forEach(function (el) {
        el.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    openers.forEach(function (el) {
      el.addEventListener('click', function () {
        setOpen(true);
      });
    });
    closers.forEach(function (el) {
      el.addEventListener('click', function () {
        setOpen(false);
      });
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && form.dataset.open === 'true') setOpen(false);
    });
  }

  function initLoadMore(root) {
    var grid = root.querySelector('[data-lmtm-grid]');
    if (!grid) return;

    root.addEventListener('click', async function (event) {
      var button = event.target.closest('[data-lmtm-load-more]');
      if (!button) return;
      event.preventDefault();

      var url = button.getAttribute('href');
      if (!url || button.classList.contains('is-loading')) return;

      button.classList.add('is-loading');
      try {
        var res = await fetch(url);
        var text = await res.text();
        var doc = new DOMParser().parseFromString(text, 'text/html');

        var nextGrid = doc.querySelector('[data-lmtm-grid]');
        if (nextGrid) {
          while (nextGrid.firstElementChild) {
            grid.appendChild(nextGrid.firstElementChild);
          }
        }

        // 次のページがあればボタンを付け替え、無ければ消す
        var nextButton = doc.querySelector('[data-lmtm-load-more]');
        if (nextButton) {
          button.setAttribute('href', nextButton.getAttribute('href'));
        } else {
          button.remove();
        }
      } catch (err) {
        // 失敗したときは普通のページ遷移に任せる
        window.location.href = url;
        return;
      } finally {
        button.classList.remove('is-loading');
      }
    });
  }

  function initToTop(root) {
    var button = root.querySelector('[data-lmtm-totop]');
    if (!button) return;

    function sync() {
      button.hidden = window.scrollY < 400;
    }

    button.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    window.addEventListener('scroll', sync, { passive: true });
    sync();
  }

  function init() {
    // [data-lmtm-list] はお知らせ一覧。VIEW MORE だけを使う（絞り込み・TOPボタンは無いので何も起きない）
    document.querySelectorAll('[data-lmtm-collection], [data-lmtm-list]').forEach(function (root) {
      initSort(root);
      initFacets(root);
      initLoadMore(root);
      initToTop(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
